export default {
  test: 'huobi test',
};


// WEBPACK FOOTER //
// ./src/locales/en-US/test.ts